import React, { Component } from 'react';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import $ from 'jquery';
import API_Config from '../../API_Config';
import './subscribe.css'

class Subscribe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count:0
        }
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {

        return (
            <section class="ind_newsletr">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 pad-top pad-bot">

                                <div class="all_logo news-text abn">
                                    <p>Industry<br class="hidden-xs"></br>
                                        NewsLetters</p>
                                </div>

                                <div class="nws-inpt input-group hidden-xs">
                                    <div class="input-group-btn search-panel">
                                        <select id="category_selected" className="form-control select_category">
                                            <option value="All">All</option>
                                            <option value="Animal_Nutrition_Wellness">Animal Nutrition Wellness</option>
                                            <option value="Financial_Services_and_Investment_Intelligence">Financial Services and Investment Intelligence</option>
                                            <option value="Real_Estate">Real Estate</option>
                                            <option value="Manufacturing_Processes_" selected="">Manufacturing Processes</option>
                                            <option value="Advanced_Technologies">Advanced Technologies</option>
                                            <option value="Advanced_Technologies">Advanced Technologies</option>
                                            <option value="Consumer_Goods_and_Services"> Consumer Goods and Services</option>
                                            <option value="Automotive">Automotive</option>
                                            <option value="Investment_Opportunities">Investment Opportunities</option>
                                            <option value="Packaging">Packaging</option>
                                            <option value="Food_&_Beverage">Food & Beverage</option>
                                            <option value="Chemicals_&_Materials">Chemicals & Materials</option>
                                            <option value="Electronics">Electronics</option>
                                            <option value="Energy_&_Power">Energy & Power</option>
                                            <option value="Agriculture">Agriculture</option>
                                            <option value="Electronics">Electronics</option>
                                            <option value="Healthcare">Healthcare</option>
                                            <option value="Automation">Automation</option>
                                            <option value="Information_&_Communications_Technology">Information & Communications Technology</option>
                                            <option value="Aerospace_&_Defense">Aerospace & Defense</option>
                                        </select>
                                    </div>
                                    <input type="hidden" name="search_param" value="Investment_Opportunities" id="search_parama" />
                                        <i class="fa fa-envelope-o ion"></i>
                                        <input type="email" class="form-control news-pad ind_search" name="email" id="email" placeholder="Please enter your Email Address . . . " required="" />
                                        <span class="input-group-btn ">
                                            <button class="btn btn-default subscibe-btn" type="button" id="news_general" onClick={this.handleSubmit}>SUBSCRIBE</button>
                                        </span>
                                </div>


                                <div class="row hidden-lg hidden-md hidden-sm">
                                    <div class="col-xs-12">
                                        <div class="input-group-btn search-panelll nws">
                                            <select id="category_selected" className="form-control">
                                                <option value="All">All</option>
                                                <option value="Animal_Nutrition_Wellness">Animal Nutrition Wellness</option>
                                                <option value="Financial_Services_and_Investment_Intelligence">Financial Services and Investment Intelligence</option>
                                                <option value="Real_Estate">Real Estate</option>
                                                <option value="Manufacturing_Processes_" selected="">Manufacturing Processes</option>
                                                <option value="Advanced_Technologies">Advanced Technologies</option>
                                                <option value="Advanced_Technologies">Advanced Technologies</option>
                                                <option value="Consumer_Goods_and_Services"> Consumer Goods and Services</option>
                                                <option value="Automotive">Automotive</option>
                                                <option value="Investment_Opportunities">Investment Opportunities</option>
                                                <option value="Packaging">Packaging</option>
                                                <option value="Food_&_Beverage">Food & Beverage</option>
                                                <option value="Chemicals_&_Materials">Chemicals & Materials</option>
                                                <option value="Electronics">Electronics</option>
                                                <option value="Energy_&_Power">Energy & Power</option>
                                                <option value="Agriculture">Agriculture</option>
                                                <option value="Electronics">Electronics</option>
                                                <option value="Healthcare">Healthcare</option>
                                                <option value="Automation">Automation</option>
                                                <option value="Information_&_Communications_Technology">Information & Communications Technology</option>
                                                <option value="Aerospace_&_Defense">Aerospace & Defense</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-xs-12">

                                            <i class="fa fa-envelope-o ion"></i>
                                            <input type="email" class="form-control news-pad mid-news" name="email" id="email1" placeholder="Enter your Email Address here  . . . " required="" />
                                    </div>
                                    <div class="col-xs-12">
			<span class="input-group-btn ">
                    <button class="btn btn-default subscibe-btn" type="button" onClick={this.handleSubmit1} id="news_resp">SUBSCRIBE</button>
                </span>
                                    </div>
                                </div>

                        </div>
                    </div>
                </div>
                <NotificationContainer  />
            </section>

        );
    }

    handleSubmit() {

        var email = $("#email").val();

        if(email ==''){
            alert("Please enter email id");
            return false;
        }
        else if(email!=''){

            var atpos = email.indexOf("@");
            var dotpos = email.lastIndexOf(".");
            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {
                alert("Enter valid email id");
                return false;
            }
            else{
                // var fd = new FormData();
                // fd.append("email",email);
                // fd.append("search_param",$('#category_selected').val());
                var postData = {
                    "email":email,
                    "search_param":$('#category_selected').val()
                }
                $.ajax({
                    type: 'POST',
                    url: "https://mordorintelligence.com:81/api/leads/subscribeNewsLetter",
                    data: postData
                })
                    .done(function (data) {
                        NotificationManager.success('Success', 'successfully Subscribed !!', 5000);


                    })
                    .fail(function (jqXhr) {
                        NotificationManager.error('Error', 'Something went wrong!', 5000);
                    });


                return false;
            }
        }
    }
    handleSubmit1() {

        var email = $("#email1").val();

        if(email ==''){
            alert("Please enter email id");
            return false;
        }
        else if(email!=''){

            var atpos = email.indexOf("@");
            var dotpos = email.lastIndexOf(".");
            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {
                alert("Enter valid email id");
                return false;
            }
            else{
                // var fd = new FormData();
                // fd.append("email",email);
                // fd.append("search_param",$('#category_selected').val());
                var postData = {
                    "email":email,
                    "search_param":$('#category_selected').val()
                }
                $.ajax({
                    type: 'POST',
                    url: "https://mordorintelligence.com:81/api/leads/subscribeNewsLetter",
                    data: postData
                })
                    .done(function (data) {
                        NotificationManager.success('Success', 'successfully Subscribed !!', 5000);


                    })
                    .fail(function (jqXhr) {
                        NotificationManager.error('Error', 'Something went wrong!', 5000);
                    });


                return false;
            }
        }
    }
}

export default Subscribe;



// WEBPACK FOOTER //
// ./src/footer/subscribe/Subscribe.js